export class CompletedUploadPart {
	public partNumber: number;
	public eTag: string;
	public isLast: boolean;
	public fileName: string;
	public partSize: number;
}
